import Link from '@/_application/core/components/ui/link';
import {useModalState} from '@/_application/core/components/ui/modal/modal.context';
import {getBrandUrl} from '@/_application/core/utils/common';
import {getRatingDataFromProduct} from '@/_application/helpers/product';
import {ProductName} from '@/_application/modules/products/components/product-name';
import {ProductRatingBox} from '@/_application/modules/products/components/ratings/product-rating-box';
import {Product} from '@/_application/modules/products/model/product';
import {useProductBrand} from '@/framework/highlight-brands';
import {useAttributes} from '@/store/attributes/attributes.context';
import {ProductInterface} from '__generated__/__types__';
import cn from 'classnames';
import {isEmpty} from 'lodash';
import {useTranslation} from 'next-i18next';

interface IProps {
    product: Product;
}

function ProductDetailsBasicInfo({product}: Readonly<IProps>) {
    const {selectedVariant} = useAttributes();
    const selectedProduct = isEmpty(selectedVariant) ? product : (selectedVariant?.product as ProductInterface);
    const {brand} = useProductBrand(product);
    const {t} = useTranslation();
    const {isOpen, view} = useModalState();
    const isModal = isOpen && view === 'PRODUCT_DETAILS';

    const productNameClasses = 'text-[22px] font-extrabold leading-[25px] text-primary';

    return (
        <div className="flex flex-col gap-1">
            <div className="block text-left">
                {isModal ? (
                    <ProductName
                        product={product}
                        className={cn(productNameClasses, {
                            'filter hover:opacity-90 hover:brightness-125': isModal,
                        })}
                    />
                ) : (
                    <h1 className={productNameClasses}>{product?.name}</h1>
                )}
            </div>

            <div className="flex items-center gap-2 text-sm">
                {brand?.label ? (
                    <>
                        <p>
                            {t('text-brand')}:{' '}
                            <Link
                                href={getBrandUrl(brand?.url ?? '')}
                                className="text-primary transition-opacity hover:opacity-80">
                                {brand?.label}
                            </Link>
                        </p>
                        <div className="h-3 w-[2px] bg-KPZ_divider" />
                    </>
                ) : null}

                <p>
                    SKU: <span className="text-primary">{selectedProduct?.sku}</span>
                </p>
            </div>

            <ProductRatingBox ratingData={getRatingDataFromProduct(product)} showAverageRating />
        </div>
    );
}

export default ProductDetailsBasicInfo;
